exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.template-panel--listItem--1rV1UfRM .template-panel--itemContentRoot--3nHHR_r5{\n    overflow: hidden;\n}\n\n.template-panel--listItem--1rV1UfRM .template-panel--itemText--2F4vKICf{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}", "", {"version":3,"sources":["/./src/web/components/themes/template-panel.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;CACpB;;AAED;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B","file":"template-panel.css","sourcesContent":["\n.listItem .itemContentRoot{\n    overflow: hidden;\n}\n\n.listItem .itemText{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "template-panel--listItem--1rV1UfRM",
	"itemContentRoot": "template-panel--itemContentRoot--3nHHR_r5",
	"itemText": "template-panel--itemText--2F4vKICf"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/template-panel.css
// module id = 2194
// module chunks = 4